import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cursos: [],
    detail: null,
    ganhadores: [],
    numeroDaSorte: []
  },
  mutations: {
    setConfig (state, payload) {
      state.config = payload
      Vue.prototype.$config = state.config
    },
    setCursos (state, payload) {
      state.cursos = payload
    },
    setDetail (state, payload) {
      state.detail = payload
    },
    setGanhadores (state, payload) {
      state.ganhadores = payload
    },
    setNumeroDaSorte (state, payload) {
      state.numeroDaSorte = payload
    }
  },
  actions: {
    cadastrar ({ state }, data) {
      return axios.post(`${state.config.urls.api_url}/alunos/create`, data).then(response => {
        Object.keys(response.data).length > 0 && sessionStorage.setItem('config', JSON.stringify(response.data))
        return Promise.resolve(response.data)
      })
    },
    getConfig ({ commit }) {
      const config = sessionStorage.getItem('config')
      if (config) {
        commit('setConfig', JSON.parse(config))
        return Promise.resolve(JSON.parse(config))
      }
      return axios.get(`${process.env.VUE_APP_WHITELABEL_API}/getConfig?project=portal-educacao-premiada-zema`).then(response => {
        commit('setConfig', response.data)
        Object.keys(response.data).length > 0 && sessionStorage.setItem('config', JSON.stringify(response.data))
        return Promise.resolve(response.data)
      })
    },
    getCursos ({ commit, state }, idSistema = 1) {
      return axios.get(`${state.config.urls.api_url}/cursos/listar?idSistema=${idSistema}&numRegPagina=250&numPagina=0&categoria=0`).then(response => {
        commit('setCursos', { ...state.cursos, [idSistema]: response.data })
      })
    },
    // detalhes do curso
    getDetail ({ commit, state }, id) {
      commit('setDetail', null)
      return axios.get(`${state.config.urls.api_url}/cursos/detalhar/${id}`).then(response => {
        commit('setDetail', response.data)
      })
    },

    getGanhadores ({ commit, state }) {
      return axios.get(`${state.config.urls.api_url}/ParcelaPremiada/ganhadores`).then(response => {
        commit('setGanhadores', response.data)
      })
    },
    getNumeroDaSorte ({ commit, state }, cpf) {
      return axios.get(`${state.config.urls.api_url}/ParcelaPremiada/NumeroSorte?id=${cpf}`).then(response => {
        const sorteios = response.data
        commit('setNumeroDaSorte', sorteios)
        return sorteios
      })
    },
    buscarLinkRaspadinha ({ commit, state }, { cpf, nrSorte }) {
      return axios.get(`${state.config.urls.api_url}/Raspadinha/BuscaLinkRaspadinha?cpf=${cpf}&nrSorte=${nrSorte}`)
    },
    getLojas ({ commit, state }) {
      return axios.get(`${state.config.urls.data_loja_json}`)
    },
    postContato ({ commit, state }, data) {
      return axios.post(`${state.config.urls.api_url}/ParcelaPremiada/contato`, data)
    },
    activateAccessCode ({ commit, state }, data) {
      return axios.post(`${state.config.urls.api_url}/codigo-acesso/ativar`, data)
    }
  }
})
